import { apiFetch } from './client';
import { parseJsonResponse } from './parseResponse';

export type DashboardCurrencyTotal = {
  currency: string;
  currency_symbol: string;
  total: number;
  count: number;
};

export type DashboardSummary = {
  stats: {
    total_revenue: {
      value: number;
      currency: string;
      currency_symbol: string;
      change: number | null;
      by_currency: DashboardCurrencyTotal[];
    };
    active_subscriptions: { value: number; change: number | null };
    new_ateliers: { value: number; change: number | null };
    churn_rate: { value: number; change: number | null };
  };
  revenue_chart: Array<{
    month: string;
    totals: Record<string, number>;
    primary_total: number;
  }>;
  growth_chart: Array<{
    month: string;
    subscriptions: number;
    ateliers: number;
  }>;
  recent_subscriptions: Array<{
    id: number;
    tenant_name: string;
    plan_name: string;
    price: string;
    currency: string;
    currency_symbol: string;
    status: string;
    created_at: string | null;
  }>;
  recent_payments: Array<{
    id: number;
    tenant_name: string;
    plan_name: string;
    amount: string;
    currency: string;
    currency_symbol: string;
    status: string;
    paid_at: string | null;
  }>;
};

export async function fetchDashboardSummary(): Promise<
  | { ok: true; data: DashboardSummary }
  | { ok: false; message: string; unauthorized?: boolean }
> {
  const res = await apiFetch('/platform/dashboard/summary');
  const out = await parseJsonResponse<DashboardSummary>(res);
  if (out.ok === false) {
    return { ok: false, message: out.message, unauthorized: out.unauthorized };
  }
  return { ok: true, data: out.data };
}
